import { createFormFromSchema, ObservableForm } from "@corets/form"
import { object, string } from "@corets/schema"

export type SearchCategoryFormType = {
  keyword?: string
  reflectionFieldId?: string
}

export const createSearchCategoryForm = (
  data?: SearchCategoryFormType
): ObservableForm<SearchCategoryFormType, SearchCategoryFormType> => {
  const form = createFormFromSchema<SearchCategoryFormType>(
    object<SearchCategoryFormType>({
      keyword: string()
        .optional()
        .toDefault(data?.keyword || ""),
      reflectionFieldId: string().optional().toDefault(data?.reflectionFieldId),
    })
  ).handler(async (form) => {
    return form.get()
  })

  return form
}
